import { ElementType, Key } from 'react';
import { map } from 'lodash/fp';

import getContentToRender from '../../utils/get-content-to-render';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

const mapWithIndex = uncapFpIterator(map);

type PageSectionsProps = {
  components: {
    [key: string]: ElementType;
  };
  content:
    | {
        sections: {
          compareButtonText?: string;
          compareButtonToLink?: string;
          productIds: string[];
          title?: string;
          type: string;
          withBorder: boolean;
        }[];
      }
    | ReturnType<typeof getContentToRender>
    | null;
};

const PageSections = ({ components, content }: PageSectionsProps) => {
  const sections = content?.sections;

  return (
    <>
      {mapWithIndex((section: { type: string }, index: Key) => {
        const Component = components[section.type] as unknown as ElementType;
        if (!Component) return null;
        return <Component key={index} {...section} />;
      }, sections)}
    </>
  );
};

export default PageSections;
